function ResidencyTag({ property }) {
  return <div className="tag">{property.label}</div>;
}

export default ResidencyTag;
